import React from 'react';
import PropTypes from 'prop-types';
import s from './MatchStatsListV2.scss';
import {
  TOI_IMAGE_DOMAIN,
  TOI_LIVE_DOMAIN,
} from '../../../../../constants/index';
import Link from '../../../../../components/Link/Link';

const MatchStatsListV2 = props => {
  if (!props) return null;

  const {
    matchStatsData,
    headToHeadMatches,
    teamaid,
    teambid,
    teamashrt_name,
    teambshrt_name,
    teamaname,
    teambname,
    thumbslist,
    //isIpl,
    tournamentName,
  } = props;

  if (!matchStatsData) return null;

  // Get head to head data
  const getHeadData = () => {
    const team = matchStatsData[teamaid];
    const headData = team?.overall?.performance_against?.team;
    let headToHeadData;
    if (headData && Array.isArray(headData) && headData.length > 0) {
      headData.filter(value => {
        if (value?.id === teambid) {
          headToHeadData = value;
        }
        return value;
      });
    }
    return headToHeadData;
  };

  const headToHeadData = getHeadData();
  const defaultThumb = `${TOI_IMAGE_DOMAIN}/thumb/msid-81945120,width-100,height-100/81945120.jpg`;

  // Get top performers data
  const teama = matchStatsData[teamaid];
  const teamb = matchStatsData[teambid];

  const headToHeadMatchData =
    headToHeadMatches &&
    Array.isArray(headToHeadMatches) &&
    headToHeadMatches.length > 0
      ? headToHeadMatches.filter(
          match =>
            (match?.id === teamaid && match?.againstteamid === teambid) ||
            (match?.id === teambid && match?.againstteamid === teamaid),
        )
      : [];

  let headToHeadMatchDataUrl = '';
  if (tournamentName === 'ipl') {
    const [iplFirstShrt, iplSecondShrt] = [
      teamashrt_name || '',
      teambshrt_name || '',
    ].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    headToHeadMatchDataUrl =
      headToHeadMatchData && headToHeadMatchData.length > 0
        ? `/sports/cricket/${iplFirstShrt}-vs-${iplSecondShrt}-head-to-head-upcoming-match-schedule-and-results/${
            headToHeadMatchData[0]?.msid
          }`
        : '';
  } else {
    headToHeadMatchDataUrl =
      headToHeadMatchData &&
      Array.isArray(headToHeadMatchData) &&
      headToHeadMatchData.length > 0
        ? `${TOI_LIVE_DOMAIN}/sports/cricket/${
            teamaname && typeof teamaname === 'string'
              ? teamaname?.toLowerCase().replace(/ /g, '-')
              : teamaname
          }-vs-${
            teambname && typeof teambname === 'string'
              ? teambname?.toLowerCase().replace(/ /g, '-')
              : teambname
          }-head-to-head-upcoming-match-schedule-and-results/${
            headToHeadMatchData[0]?.msid
          }`
        : '';
  }

  const topPerformersTeama =
    teama?.overall?.last_twelve_months?.top_performer?.record;
  const topPerformersTeamb =
    teamb?.overall?.last_twelve_months?.top_performer?.record;

  return (
    <>
      <div className={s.heading}>
        <h3>
          {headToHeadMatchDataUrl && headToHeadMatchDataUrl !== '' ? (
            <Link to={headToHeadMatchDataUrl}>
              {teamaname || ''} vs {teambname || ''} Head to Head
            </Link>
          ) : (
            <span>
              {teamaname || ''} vs {teambname || ''} Head to Head
            </span>
          )}
        </h3>
      </div>
      <div className={s.matchStatsContainer}>
        <div className={s.matchTitle}>
          <div className={s.titleWrapper}>
            <div className={s.teamDetail}>
              <div className={s.left}>
                <div className={s.flag}>
                  <i
                    className={`${
                      s[teamashrt_name ? teamashrt_name.toUpperCase() : '']
                    } 
                        ${s.flagIcon}`}
                  />
                </div>
                <strong>{teamashrt_name}</strong>
              </div>
              <i className={s.vsIcon} />
              <div className={s.right}>
                <strong>{teambshrt_name}</strong>
                <div className={s.flag}>
                  <i
                    className={`${
                      s[teambshrt_name ? teambshrt_name.toUpperCase() : '']
                    } ${s.flagIcon}`}
                  />
                </div>
              </div>
            </div>
            {matchStatsData &&
              matchStatsData[teamaid] &&
              matchStatsData[teamaid]?.ranking !== '' &&
              matchStatsData[teamaid]?.ranking !== '-' &&
              matchStatsData[teambid]?.ranking !== '-' &&
              matchStatsData[teambid]?.ranking !== '-' && (
                <div className={s.odiRankingWrap}>
                  <div className={s.odiRanking}>
                    <div className={s.title}>
                      {(() => {
                        const compType = matchStatsData[teamaid]?.comp_type;
                        const rankingText = `${compType} Ranking`;

                        if (compType === 'T20') {
                          return (
                            <Link
                              to={`${TOI_LIVE_DOMAIN}/sports/cricket/icc-t20-team-rankings`}
                            >
                              {rankingText}
                            </Link>
                          );
                        }
                        if (compType === 'ODI') {
                          return (
                            <Link
                              to={`${TOI_LIVE_DOMAIN}/sports/cricket/icc-odi-team-rankings`}
                            >
                              {rankingText}
                            </Link>
                          );
                        }
                        if (compType === 'Test') {
                          return (
                            <Link
                              to={`${TOI_LIVE_DOMAIN}/sports/cricket/icc-rankings`}
                            >
                              {rankingText}
                            </Link>
                          );
                        }
                        return <span>{rankingText}</span>;
                      })()}
                    </div>

                    <div className={s.rankings}>
                      <span>
                        {teamashrt_name || ''} :
                        <strong>{matchStatsData[teamaid]?.ranking}</strong>
                      </span>
                      <span>
                        {teambshrt_name || ''} :
                        <strong>{matchStatsData[teambid]?.ranking}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>

        <div className={s.headToHeadWrap}>
          {/* Head to Head Stats */}
          <div className={s.headToHeadStats}>
            <div className={s.title}>
              {headToHeadMatchDataUrl && headToHeadMatchDataUrl !== '' ? (
                <Link to={headToHeadMatchDataUrl}>
                  {teamashrt_name.toUpperCase()} vs{' '}
                  {teambshrt_name.toUpperCase()}
                </Link>
              ) : (
                `${teamashrt_name.toUpperCase()} vs ${teambshrt_name.toUpperCase()}`
              )}
            </div>
            <div className={s.matchStats}>
              <div className={s.statText}>
                <span>{teamashrt_name}</span> Won:{' '}
                <strong>{headToHeadData?.matches_won}</strong>
              </div>
              <div className={s.statText}>
                Played: <strong>{headToHeadData?.matches_played}</strong>
              </div>
              <div className={s.statText}>
                <span>{teambshrt_name}</span> Won:{' '}
                <strong>{headToHeadData?.matches_lost}</strong>
              </div>
            </div>
          </div>

          {/* Performance Stats */}
          <div className={s.performanceStats}>
            <div className={s.title}>Performance in Last 1 Year</div>
            <div className={s.statsTable}>
              <div className={`${s.teamRow} ${s.teamHeader}`}>
                <div className={s.teamInfo}>
                  <span>Team</span>
                </div>
                <div className={s.teamStats}>
                  <span className={s.play}>Played</span>
                  <span className={s.won}>Won</span>
                  <span className={s.lost}>Lost</span>
                  <span className={s.winPercent}>Win%</span>
                </div>
              </div>
              <div className={`${s.teamRow}`}>
                <div className={s.teamInfo}>
                  <i
                    className={`${s.flagIcon} ${
                      s[teamashrt_name?.toUpperCase()]
                    }`}
                  />
                  <span>{teamashrt_name.toUpperCase()}</span>
                </div>
                <div className={s.teamStats}>
                  <strong className={s.play}>
                    {teama?.overall?.last_twelve_months?.matches_played}
                  </strong>
                  <strong className={s.won}>
                    {teama?.overall?.last_twelve_months?.matches_won}
                  </strong>
                  <strong className={s.lost}>
                    {teama?.overall?.last_twelve_months?.matches_lost}
                  </strong>
                  <strong className={s.winPercent}>
                    {teama?.overall?.last_twelve_months?.win_percentage}%
                  </strong>
                </div>
              </div>

              <div className={`${s.teamRow}`}>
                <div className={s.teamInfo}>
                  <i
                    className={`${s.flagIcon} ${
                      s[teambshrt_name?.toUpperCase()]
                    }`}
                  />
                  <span>{teambshrt_name.toUpperCase()}</span>
                </div>
                <div className={s.teamStats}>
                  <strong className={s.play}>
                    {teamb?.overall?.last_twelve_months?.matches_played}
                  </strong>
                  <strong className={s.won}>
                    {teamb?.overall?.last_twelve_months?.matches_won}
                  </strong>
                  <strong className={s.lost}>
                    {teamb?.overall?.last_twelve_months?.matches_lost}
                  </strong>
                  <strong className={s.winPercent}>
                    {teamb?.overall?.last_twelve_months?.win_percentage}%
                  </strong>
                </div>
              </div>
            </div>
          </div>

          {/* Top Performers */}
          <div className={s.topPerformers}>
            <div className={s.title}>Top Performers In Last 1 Year</div>
            <div className={s.performersGrid}>
              <div className={s.playerRow}>
                {/* Team A Top Performers */}
                {topPerformersTeama &&
                  Array.isArray(topPerformersTeama) &&
                  topPerformersTeama?.map((value, index) => {
                    const playerkey =
                      value?.name
                        ?.split(' ')
                        .join('-')
                        .toUpperCase() || null;
                    const playerLink = tournamentName
                      ? `${TOI_LIVE_DOMAIN}/sports/cricket/${tournamentName}/player-stats/${playerkey?.toLowerCase()}/${
                          value?.id
                        }`
                      : `${TOI_LIVE_DOMAIN}/sports/cricket/player-profile/${playerkey?.toLowerCase()}/${
                          value?.id
                        }`;
                    // `${TOI_LIVE_DOMAIN}/topic/${playerkey}`;
                    return (
                      <div className={s.playerCardWrap} key={`teama-${index}`}>
                        <Link to={playerLink}>
                          <div className={s.playerCard}>
                            <div className={s.playerImage}>
                              <img
                                src={
                                  thumbslist?.[playerkey]?.strimg ||
                                  defaultThumb
                                }
                                alt={value?.name}
                              />
                            </div>
                            <div className={s.playerInfo}>
                              <div className={s.nameWithFlag}>
                                <span>{value?.name}</span>
                                <i
                                  className={`${s.flagIcon} ${
                                    s[teamashrt_name?.toUpperCase()]
                                  }`}
                                />
                              </div>
                              <strong className={s.stats}>
                                <i
                                  className={`${s.statIcon} ${
                                    value?.type === 'bowling'
                                      ? s.bowlingIcon
                                      : s.battingIcon
                                  }`}
                                />
                                {value?.value}{' '}
                                {value?.type === 'bowling' ? 'Wickets' : 'Runs'}
                              </strong>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
              <div className={s.playerRow}>
                {topPerformersTeamb &&
                  Array.isArray(topPerformersTeamb) &&
                  topPerformersTeamb?.map((value, index) => {
                    const playerkey =
                      value?.name
                        ?.split(' ')
                        .join('-')
                        .toUpperCase() || null;
                    const playerLink = tournamentName
                      ? `${TOI_LIVE_DOMAIN}/sports/cricket/${tournamentName}/player-stats/${playerkey?.toLowerCase()}/${
                          value?.id
                        }`
                      : `${TOI_LIVE_DOMAIN}/sports/cricket/player-profile/${playerkey?.toLowerCase()}/${
                          value?.id
                        }`;
                    // `${TOI_LIVE_DOMAIN}/topic/${playerkey}`;
                    return (
                      <div className={s.playerCardWrap} key={`teamb-${index}`}>
                        <Link to={playerLink}>
                          <div className={s.playerCard}>
                            <div className={s.playerImage}>
                              <img
                                src={
                                  thumbslist?.[playerkey]?.strimg ||
                                  defaultThumb
                                }
                                alt={value?.name}
                              />
                            </div>
                            <div className={s.playerInfo}>
                              <div className={s.nameWithFlag}>
                                <span>{value?.name}</span>
                                <i
                                  className={`${s.flagIcon} ${
                                    s[teambshrt_name?.toUpperCase()]
                                  }`}
                                />
                              </div>
                              <strong className={s.stats}>
                                <i
                                  className={`${s.statIcon} ${
                                    value?.type === 'bowling'
                                      ? s.bowlingIcon
                                      : s.battingIcon
                                  }`}
                                />
                                {value?.value}{' '}
                                {value?.type === 'bowling' ? 'Wickets' : 'Runs'}
                              </strong>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

MatchStatsListV2.propTypes = {
  matchStatsData: PropTypes.object,
  teamaid: PropTypes.string.isRequired,
  teambid: PropTypes.string.isRequired,
  teamashrt_name: PropTypes.string.isRequired,
  teambshrt_name: PropTypes.string.isRequired,
  teamaname: PropTypes.string.isRequired,
  teambname: PropTypes.string.isRequired,
  thumbslist: PropTypes.object,
  tournamentName: PropTypes.string,
};

MatchStatsListV2.defaultProps = {
  matchStatsData: null,
  thumbslist: null,
  tournamentName: '',
};

export default MatchStatsListV2;
